import styled from "styled-components";

export const ListStyles = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
